<div class="sectionContainer" *ngIf="hasVisibleData">
    <h3>Final Investment Decision</h3>
    <table class="projectSectionTable">
        <tr>
            <td *ngIf="fid?.expected">
                <span style="font-weight: bold">FID Expected:&nbsp;</span>
                <span>{{fid.expected | date:'MMMM yyyy'}}</span>
                <span *ngIf="fid?.expectedQualifier">
                    ({{fid.expectedQualifier}})
                </span>
            </td>
            <td *ngIf="fid?.received">
                <span style="font-weight: bold">FID Received:&nbsp;</span>
                <span>{{fid.received | date:'MMMM yyyy'}}</span>
                <span *ngIf="fid?.receivedQualifier">
                    ({{fid.receivedQualifier}})
                </span>
            </td>
            <td *ngIf="shouldRenderPendingReceived">
                <span style="font-weight: bold">FID Received:&nbsp;</span>
                <span>Pending</span>
            </td>

            <td *ngIf="fid?.debtEquityRatio !== undefined && fid?.debtEquityRatio !== null">
                <span style="font-weight: bold">Debt/Equity Ratio:&nbsp;</span>
                <span>{{fid.debtEquityRatio}}%</span>
            </td>

        </tr>
    </table>

</div>
